import { RouteObject } from 'react-router';
import { ProtectedRoute } from '@/routes/ProtectedRoute';
import { Permission } from '@/utils/roles';
import { EfaxFeatureGate } from './components/EfaxFeatureGate';
import { EfaxPage } from './components/EfaxPage';

export const efaxRoutes: RouteObject[] = [
  {
    element: (
      <ProtectedRoute requiredPermissions={[Permission.VIEW_EFAX]}>
        <EfaxFeatureGate>
          <EfaxPage />
        </EfaxFeatureGate>
      </ProtectedRoute>
    ),
    path: '',
  },
];
